<template>
  <div v-if="customer">
    <div class="row">
      <div class="col-md-12">
        <div class="card-box" style="padding: 0">
          <el-menu :default-active="tabs.default" class="el-menu-no-bg" mode="horizontal" @select="handleTabs">
            <el-menu-item index="summary">Vue d'ensemble</el-menu-item>
            <el-menu-item index="services_documents">Services & Documents</el-menu-item>
            <el-menu-item index="emails">Emails</el-menu-item>
            <el-submenu index="empty">
              <template slot="title">Liaisons</template>
              <el-menu-item index="devis-b2b">Devis B2B
                <span class="label label-success" v-if="customer.sources['devis-b2b']">Modifier</span>
                <span class="label label-warning" v-else>Créer</span>
              </el-menu-item>
              <el-menu-item index="communication">Communication
                <span class="label label-success" v-if="customer.sources['communication']">Modifier</span>
                <span class="label label-warning" v-else>Créer</span>
              </el-menu-item>
            </el-submenu>
          </el-menu>
        </div>
      </div>
    </div>
    <div class="row" v-if="tabs.active === 'summary'">
      <div class="col-md-4 col-lg-3">
        <customer-informations-summary-widget :customer="customer"></customer-informations-summary-widget>
        <customer-contacts-summary-widget :customer="customer"></customer-contacts-summary-widget>
        <customer-administration-summary-widget :customer="customer"></customer-administration-summary-widget>
      </div>
      <div class="col-md-8 col-lg-6">
        <customer-timeline-summary-widget
          :customer="customer"
          :relations="relations"
          :interface="'COMMERCIAL'"
        ></customer-timeline-summary-widget>
      </div>
      <div class="col-md-12 col-lg-3">
        <customer-billing-summary-widget :customer="customer"></customer-billing-summary-widget>
        <customer-services-summary-widget :customer="customer" @show="handleShow"></customer-services-summary-widget>
        <customer-propositions-summary-widget
          :customer="customer"
          :relations="relations"
          @show="handleShow"
        ></customer-propositions-summary-widget>
        <div class="card-box">
          <h4 class="header-title m-t-0 m-b-20">Liaisons</h4>
          <ul class="ul-fa">
            <li v-if="customer.sources['devis-b2b']" class="text-success"><i class="fa fa-check"></i> Devis B2B</li>
            <li v-else class="text-danger"><i class="fa fa-times"></i> Devis B2B</li>

            <li v-if="customer.sources['communication']" class="text-success"><i class="fa fa-check"></i> Communication
            </li>
            <li v-else class="text-danger"><i class="fa fa-times"></i> Communication</li>

            <li v-if="customer.sources['sellsy-comweb']" class="text-success"><i class="fa fa-check"></i> Sellsy ComWeb
            </li>
            <li v-else class="text-danger"><i class="fa fa-times"></i> Sellsy ComWeb</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="row" v-if="tabs.active === 'services_documents'">
      <div class="col-md-12">
        <services-and-documents :customer="customer" :relations="relations"></services-and-documents>
      </div>
    </div>
    <div class="row" v-if="tabs.active === 'emails'">
      <div class="col-md-12">
        <emails :customer="customer" :relations="relations"></emails>
      </div>
    </div>
    <div class="row" v-if="tabs.active === 'devis-b2b'" v-loading.body="iframe.loading">
      <div class="col-md-12">
        <iframe @load="iframeLoaded" :src="getCustomerUrl('devis-b2b')"
                :style="{ width: '100%', height: iframe.size + 'px', border: 0}"></iframe>
      </div>
      <div style="position: fixed; left: 100px; bottom: 40px; background: white; padding: 10px;">
        <a :href="getCustomerUrl('devis-b2b')" target="_blank"><i class="fa fa-external-link" aria-hidden="true"></i>
          Ouvrir dans un nouvel onglet</a>
      </div>
    </div>
    <div class="row" v-if="tabs.active === 'communication'" v-loading.body="iframe.loading">
      <div class="col-md-12">
        <iframe @load="iframeLoaded" :src="getCustomerUrl('communication')"
                :style="{ width: '100%', height: iframe.size + 'px', border: 0}"></iframe>
      </div>
      <div style="position: fixed; left: 100px; bottom: 40px; background: white; padding: 10px;">
        <a :href="getCustomerUrl('communication')" target="_blank"><i class="fa fa-external-link"
                                                                      aria-hidden="true"></i>
          Ouvrir dans un nouvel onglet</a>
      </div>
    </div>
  </div>
  <div v-else :v-loading="true" class="content-loading"></div>
</template>

<script>
  import moment from 'moment'
  import { events } from '@/services/event-bus.js'
  import User from '@db2b/keystone/components/Entities/User.vue'
  import UserSelect from '@db2b/keystone/components/Entities/Selects/UserSelect.vue'
  import Customer from '@db2b/keystone/components/Entities/Customer.vue'
  import SourceApp from '@db2b/keystone/components/Entities/SourceApp.vue'

  import Emails from './Customers/Emails.vue'
  import CustomerInformationsSummaryWidget from '@db2b/keystone/components/Widgets/Customers/Summary/CustomerInformationsSummaryWidget.vue'
  import CustomerContactsSummaryWidget from '@db2b/keystone/components/Widgets/Customers/Summary/CustomerContactsSummaryWidget.vue'
  import CustomerAdministrationSummaryWidget from '@db2b/keystone/components/Widgets/Customers/Summary/CustomerAdministrationSummaryWidget.vue'
  import CustomerTimelineSummaryWidget from '@db2b/keystone/components/Widgets/Customers/Summary/Timeline/CustomerTimelineSummaryWidget.vue'
  import CustomerBillingSummaryWidget from '@db2b/keystone/components/Widgets/Customers/Summary/CustomerBillingSummaryWidget.vue'
  import CustomerServicesSummaryWidget from '@db2b/keystone/components/Widgets/Customers/Summary/CustomerServicesSummaryWidget.vue'
  import CustomerPropositionsSummaryWidget from '@db2b/keystone/components/Widgets/Customers/Summary/CustomerPropositionsSummaryWidget.vue'
  import ServicesAndDocuments from './Customers/ServiceAndDocuments.vue'

  export default {
    name: 'customers',
    components: {
      ServicesAndDocuments,
      CustomerPropositionsSummaryWidget,
      CustomerServicesSummaryWidget,
      CustomerBillingSummaryWidget,
      CustomerTimelineSummaryWidget,
      CustomerAdministrationSummaryWidget,
      CustomerContactsSummaryWidget,
      CustomerInformationsSummaryWidget,
      Emails,
      SourceApp,
      Customer,
      UserSelect,
      User
    },
    data () {
      return {
        customer: null,
        tabs: {
          default: 'summary',
          active: 'summary'
        },
        iframe: {
          loading: true,
          size: 0
        },
        relations: {
          comments: [],
          calls: [],
          reminders: [],
          estimates: [],
          contracts: [],
          invoices: [],
          uploads: [],
          proposals: [],
          emails: []
        }
      }
    },
    sync: {
      customer () {
        return {
          name: 'customer',
          onUpdate ({model}) {
            if (this.customer.id === model.id) {
              this.customer = model
            }
          },
          onDelete ({model}) {
            if (this.customer.id === model.id) {
              this.$route.push('customers')
            }
          }
        }
      },
      relations: {
        comments () { return this.getCustomerRelationSync('comment') },
        calls () { return this.getCustomerRelationSync('call') },
        reminders () { return this.getCustomerRelationSync('reminder') },
        estimates () { return this.getCustomerRelationSync('estimate') },
        contracts () { return this.getCustomerRelationSync('contract') },
        invoices () { return this.getCustomerRelationSync('invoice') },
        uploads () { return this.getCustomerRelationSync('upload') },
        proposals () { return this.getCustomerRelationSync('proposal') },
        emails () { return this.getCustomerRelationSync('email') }
      }
    },
    methods: {
      load () {
        let self = this

        this.$nexus.get('crm2', 'customers', {params: {where: {id: parseInt(self.$route.params.id)}}}).then(response => {
          self.customer = response.data.data[0]

          // Refresh the title of the page
          self.refreshTitle()
        })

        // Load all relations of the customer
        let resources = {
          document2: ['invoices', 'contracts', 'estimates', 'uploads'],
          callcenter: ['calls', 'proposals', 'reminders'],
          crm2: ['comments']
        }
        for (let name in resources) {
          for (let i = 0; i < resources[name].length; i++) {
            this.$nexus.get(name, resources[name][i], {params: {where: {customer_id: self.$route.params.id}}})
              .then(response => {
                self.relations[resources[name][i]] = response.data.data
              })
          }
        }
      },
      handleShow (element) {
        this.tabs.active = element
      },
      moment () {
        return moment()
      },
      handleTabs (key, keyPath) {
        this.iframe.loading = true
        this.tabs.active = key
      },
      iframeLoaded () {
        this.iframe.size = window.jQuery(window).height() - 200
        this.iframe.loading = false
      },
      getCustomerUrl (name) {
        let tld = location.hostname.split('.').slice(-2).join('.')
        if (tld === 'localhost') {
          tld = 'devis-b2b.localhost'
        }

        if (typeof this.customer.sources[name] !== 'undefined') {
          var url = this.customer.source_fields[name].urls.edit
          return url.replace('devis-b2b.com', tld) + '?nexus_token=' + this.$nexus.getToken()
        } else {
          if (name === 'devis-b2b') {
            return 'https://construction.' + tld + '/agency/create?nexus_token=' + this.$nexus.getToken() + '&customer_id=' + this.customer.id
          } else if (name === 'communication') {
            return 'https://communication.' + tld + '/clients/create?nexus_token=' + this.$nexus.getToken() + '&customer_id=' + this.customer.id
          }
        }
      },
      refreshTitle () {
        if (this.customer) {
          this.$store.commit('app/ui/changeTitle', this.customer.name + ' (' + this.customer.address.zip_code + ')')

          if (this.customer.type === 'CLIENT') {
            this.$store.commit('app/ui/changeSubtitle', 'Fiche du client, gestion des contacts et services.')
          } else {
            this.$store.commit('app/ui/changeSubtitle', 'Fiche du prospect : gestion proactive.')
          }
        }
      },
      getCustomerRelationSync (name) {
        return {
          name,
          onCreate ({index, data, model}) {
            if (model.customer_id === this.customer.id && index === -1) data.push(model)
          }
        }
      }
    },
    computed: {
      user () {
        return this.$store.getters['users/current']
      },
      users () {
        return this.$store.getters['users/all']
      }
    },
    watch: {
      '$route' () {
        if (this.$route.name === 'customer') {
          this.load()
        }
      }
    },
    created () {
      let self = this

      window.jQuery(window).resize(function () {
        self.iframe.size = window.jQuery(window).height() - 200
      })

      this.load()
      events.on('app/ui/customer/reload', () => {
        self.load()
      })
    },
    activated () {
      this.refreshTitle()
    }
  }
</script>



// WEBPACK FOOTER //
// Customers.vue?efc72928